import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { sprintf } from 'sprintf-js';

var tinCannyDashboard = null;

jQuery(document).ready(function ($) {
	tinCannyDashboard = {
		init: function () {
			this.insertHTML();
			this.getData();
			this.groupSelector();
		},

		insertHTML: function () {
			// Get elements
			let $dashboard = $(this.html);

			// Get container
			let $container;

			if ($('#dashboard-widgets-wrap').length > 0) {
				$container = $('#dashboard-widgets-wrap').prev();
			} else if ($('#uo-welcome-panel').length > 0) {
				$container = $('#uo-welcome-panel').parent();
			} else {
				$container = $('#coursesOverviewGraphHeading');
			}

			// Get mainContainer
			let $mainContainer = $('.tclr.wrap');

			// Get context
			// Values:
			// - dashboard:  WP Admin main page
			// - plugin:     The Tin Canny Dashboard page
			// - frontend:   Frontend
			let context = reportingApiSetup.page;
			context = context == 'reporting' && $('body').hasClass('wp-admin') ? 'plugin' : context;
			context = context == 'reporting' ? 'frontend' : context;

			// Filter HTML and add context class
			if (context == 'plugin') {
				$mainContainer.addClass('uo-reporting--plugin');
				$dashboard.find('.reporting-dashboard-col-3').remove();
			}

			if (context == 'frontend') {
				$mainContainer.addClass('uo-reporting--frontend');
				$dashboard.find('.reporting-dashboard-col-3').remove();
			}

			if (context == 'dashboard') {
				$mainContainer.addClass('uo-reporting--dashboard');

				// Add class to the dashboard container
				$dashboard.addClass('uo-reporting--dashboard');
			}

			// Check if we have to remove the Tin Can report button
			if (reportingApiSetup.showTinCanTab == '0') {
				$dashboard.find('.reporting-dashboard-quick-links__item[data-id="tin-can"]').remove();
			}

			// Save context
			this.context = context;

			// Insert HTML
			$dashboard.insertAfter($container);
		},

		getData: function () {
			// Create variable to save AJAX
			let coursesOverviewApiCall;

			if (typeof reportingApiSetup.isolated_group_id == 'string' && parseInt(reportingApiSetup.isolated_group_id)) {
				if (this.context == 'dashboard') {
					coursesOverviewApiCall = this.restCall('/?group_id=' + reportingApiSetup.isolated_group_id);
				}
			} else {
				if (this.context == 'dashboard') {
					coursesOverviewApiCall = this.restCall();
				}
			}

			if (this.context == 'dashboard') {
				// On success
				coursesOverviewApiCall.done((response) => {
					this.dataObject = response;

					this.renderData();

					// Trigger tab selection to render the tables
					// Get current tab
					let $tabs = $('.uo-admin-reporting-tabs');

					// Check if the element exists
					if ($tabs.length > 0) {
						// Get id of current tab
						let activeTab = $tabs.data('tab_on_load');

						// Trigger click on tab
						$(`.uo-admin-reporting-tabs .nav-tab[data-tab_id="${activeTab}"]`).trigger('click');
					}
				});

				// On error
				coursesOverviewApiCall.fail((response) => {
					// Append error message
					$('#wpbody-content').append($('<div/>', {
						id: 'api-error',
						text: response.responseText
					}));
				});
			}
		},

		restCall: function (parameters = '') {
			return $.ajax({
				url: `${reportingApiSetup.root}dashboard_data${parameters}`,
				beforeSend: (xhr) => {
					xhr.setRequestHeader('X-WP-Nonce', reportingApiSetup.nonce);
				},
			});
		},

		renderData: function () {
			// Create metaboxes
			this.metaboxReports();
			this.metaboxRecentActivity();
			this.metaboxMostAndLeastCompletedCourses();
		},

		metaboxReports: function () {
			// Bind links
			$('.reporting-dashboard-quick-links__item').on('click', (event) => {
				window.location.href = `${this.dataObject?.report_link ?? '/wp-admin/admin.php?page=uncanny-learnDash-reporting'}${$(event.currentTarget).data('append')}`;
			});

			// Fill quick data numbers
			$('.reporting-dashboard-quick-stats__item').each((index, element) => {
				// Get elements
				let $item = $(element),
					$number = $item.find('.reporting-dashboard-quick-stats__number'),
					// Get id
					id = $item.data('id');

				// First, define default value
				let number = 0;
				// Get number depending of the id
				switch (id) {
					case 'users':
						number = this.dataObject?.total_users ?? 0;
						break;

					case 'courses':
						number = this.dataObject?.total_courses ?? 0;
						break;
				}

				// Add number to the container
				$number.text(number);

				// Add ready class
				$item.addClass('reporting-dashboard-quick-stats__item--ready');
			});
		},

		metaboxRecentActivity: function () {
			// Assuming dataObject is available in your scope
			var dataObject = this.dataObject?.courses_tincan_completed ?? {};

			// AM5 Chart (Tin Can)
			am5.ready(function () {
				// Ensure the DOM element exists
				var chartContainer = document.getElementById('reporting-recent-activities');
				if (!chartContainer) {
					//console.error('Element with ID "reporting-recent-activities" not found');
					return;
				}

				// Create root element
				var root = am5.Root.new('reporting-recent-activities');

				// Set themes
				root.setThemes([am5themes_Animated.new(root)]);

				// Create chart
				var chart = root.container.children.push(
					am5xy.XYChart.new(root, {
						panX: false,
						panY: false,
						wheelX: 'panX',
						wheelY: 'zoomX',
						paddingLeft: 0,
						layout: root.verticalLayout
					})
				);

				// Add scrollbar
				chart.set(
					'scrollbarX',
					am5.Scrollbar.new(root, {
						orientation: 'horizontal'
					})
				);

				var data = dataObject;

				// Create x-axis for bottom
				var xRenderer = am5xy.AxisRendererX.new(root, {
					minGridDistance: 60
				});
				var xAxis = chart.xAxes.push(
					am5xy.CategoryAxis.new(root, {
						categoryField: 'date',
						renderer: xRenderer,
						tooltip: am5.Tooltip.new(root, {})
					})
				);

				xAxis.get('tooltip').label.setAll({
					fontSize: '12px'
				});

				xRenderer.labels.template.setAll({
					fontSize: '12px'
				});
				xRenderer.grid.template.setAll({
					location: 1
				});

				// Create x-axis for top
				var topXAxisRenderer = am5xy.AxisRendererX.new(root, {
					opposite: true
				});
				var topXAxis = chart.xAxes.push(
					am5xy.CategoryAxis.new(root, {
						categoryField: 'date',
						renderer: topXAxisRenderer
					})
				);
				topXAxisRenderer.labels.template.setAll({
					fontSize: '12px'
				});
				topXAxisRenderer.labels.template.adapters.add('text', function (text, target) {
					var dataItem = target.dataItem;
					if (dataItem) {
						var category = dataItem.get('category');
						var date = new Date(category);
						var options = { year: 'numeric', month: 'short' };
						return date.toLocaleDateString(undefined, options);
					}
					return text;
				});

				xAxis.data.setAll(data);
				topXAxis.data.setAll(data);

				// Format bottom x-axis labels
				xAxis.get('renderer').labels.template.adapters.add('text', function (text, target) {
					var dataItem = target.dataItem;
					if (dataItem) {
						var category = dataItem.get('category');
						var date = new Date(category);
						var options = { month: 'short', day: 'numeric' };
						return date.toLocaleDateString(undefined, options);
					}
					return text;
				});

				var yAxis1 = chart.yAxes.push(
					am5xy.ValueAxis.new(root, {
						min: 0,
						extraMax: 0.1,
						renderer: am5xy.AxisRendererY.new(root, {
							strokeOpacity: 0.1,
							stroke: am5.color(0x4682B4) // Bluish color for yAxis1 (Courses)
						})
					})
				);

				yAxis1.get('renderer').labels.template.setAll({
					fontSize: '12px'
				});

				var yAxis2 = chart.yAxes.push(
					am5xy.ValueAxis.new(root, {
						min: 0,
						extraMax: 0.1,
						renderer: am5xy.AxisRendererY.new(root, {
							opposite: true,
							strokeOpacity: 0.1,
							stroke: am5.color(0x8A2BE2) // Purplish color for yAxis2 (Tin Can)
						})
					})
				);

				yAxis2.get('renderer').labels.template.setAll({
					fontSize: '12px'
				});

				// Add series
				var series1 = chart.series.push(
					am5xy.ColumnSeries.new(root, {
						name: 'Course Completions',
						xAxis: xAxis,
						yAxis: yAxis1,
						valueYField: 'completions',
						categoryXField: 'date',
						tooltip: am5.Tooltip.new(root, {
							pointerOrientation: 'horizontal',
							labelText: '[fontSize: 12px]Completions on {categoryX.formatDate("MMM dd")}: {valueY} {info}[/]'
						})
					})
				);

				series1.columns.template.setAll({
					tooltipY: am5.percent(10),
					templateField: 'columnSettings',
					fill: am5.color(0x4682B4),
					stroke: am5.color(0x4682B4),
					fillOpacity: 0.5,
					strokeWidth: 2,
					cornerRadiusTL: 5,
					cornerRadiusTR: 5
				});

				series1.data.setAll(data);

				var series2 = chart.series.push(
					am5xy.LineSeries.new(root, {
						name: 'Tin Can Statements',
						xAxis: xAxis,
						yAxis: yAxis2,
						valueYField: 'tinCan',
						categoryXField: 'date',
						tooltip: am5.Tooltip.new(root, {
							pointerOrientation: 'horizontal',
							labelText: '[fontSize: 12px]Statements on {categoryX.formatDate("MMM dd")}: {valueY} {info}[/]'
						}),
						fill: am5.color(0x8A2BE2),
						stroke: am5.color(0x8A2BE2)
					})
				);

				series2.strokes.template.setAll({
					strokeWidth: 3,
					templateField: 'strokeSettings'
				});

				series2.data.setAll(data);

				series2.bullets.push(function () {
					return am5.Bullet.new(root, {
						sprite: am5.Circle.new(root, {
							strokeWidth: 3,
							stroke: series2.get('stroke'),
							radius: 5,
							fill: root.interfaceColors.get('background')
						})
					});
				});

				chart.set('cursor', am5xy.XYCursor.new(root, {}));

				// Add legend
				var legend = chart.children.push(
					am5.Legend.new(root, {
						centerX: am5.p50,
						x: am5.p50
					})
				);
				legend.data.setAll(chart.series.values);

				// Set smaller font size for legend
				legend.labels.template.setAll({
					fontSize: '12px'
				});

				// Make stuff animate on load
				chart.appear(1000, 100);
				series1.appear();
				series2.appear();

				// Remove the .reporting-dashboard-status class div after the chart has fully loaded
				$('#reporting-recent-activities .reporting-dashboard-status').remove();
			});
		},

		metaboxMostAndLeastCompletedCourses: function () {
			// Get list
			let courses = this.dataObject?.top_course_completions ?? {}
			// Get parts (top, middle, bottom)
			let coursesRanking = {
				top: [],
				middle: [],
				bottom: []
			};

			if (courses.length > 0) {
				// Clean data
				courses = courses.map((element) => {
					// Return new object
					return {
						percentage: element.percentage,
						title: element.post_title
					}
				});

				// Sort data (already sorted in PHP, so this is redundant but included for clarity)
				courses = courses.sort((a, b) => b.percentage - a.percentage);

				// Add element number
				courses = courses.map((element, index) => {
					return Object.assign({}, element, {
						order: index + 1
					});
				});

				let coursesCopy = courses.slice(0);

				// Get best ones
				coursesRanking.top = coursesCopy.slice(0, 3);
				coursesCopy = coursesCopy.slice(3);

				// Get the ones at the bottom
				if (coursesCopy.length <= 3) {
					coursesRanking.bottom = coursesCopy;
					coursesCopy = [];
				} else {
					coursesRanking.bottom = coursesCopy.slice(coursesCopy.length - 3, coursesCopy.length);
					coursesCopy = coursesCopy.slice(0, coursesCopy.length - 3);
				}

				// Get the ones at the middle
				coursesRanking.middle = coursesCopy;

			}
			// Get container where we're going to insert the list of courses
			let $container = $('#reporting-completed-ranking');

			// Remove loading data
			$container.html('');

			// Create function to create elements
			let createRow = (course) => {
				return `
                    <div class="reporting-completed-ranking__item">
                        <div class="reporting-completed-ranking__order">${course.order}</div>
                        <div class="reporting-completed-ranking__title">${course.title}</div>
                        <div class="reporting-completed-ranking__percentage">${course.percentage}%</div>
                    </div>
                `;
			}

			// Check if we have items to add
			if (courses.length > 0) {
				// Add elements to the container
				if (coursesRanking.top.length > 0) {
					$container.append($(`
                        <div class="reporting-completed-ranking__top">
                            ${coursesRanking.top.map((element) => {
							return createRow(element);
						}).join('')}
                        </div>`
					));
				}

				if (coursesRanking.middle.length > 0) {
					$container.append($(`
                        <div class="reporting-completed-ranking__middle">
                            <div id="reporting-completed-ranking-middle__points" class="reporting-completed-ranking-middle__points" tclr-tooltip="${sprintf(reportingApiSetup.localizedStrings.overviewBoxesReportsCoursesCompletionSeeAll, reportingApiSetup.learnDashLabels.courses.toLowerCase())}">
                                ···
                            </div>
                            <div id="reporting-completed-ranking-middle__items" class="reporting-completed-ranking-middle__items">
                                ${coursesRanking.middle.map((element) => {
							return createRow(element);
						}).join('')}
                            </div>
                        </div>`
					));
				}

				if (coursesRanking.bottom.length > 0) {
					$container.append($(`
                        <div class="reporting-completed-ranking__bottom">
                            ${coursesRanking.bottom.map((element) => {
							return createRow(element);
						}).join('')}
                        </div>`
					));
				}
			} else {
				// Add "No course completions" notice
				// Create notice
				let $notice = $(`
                    <div class="reporting-dashboard-status reporting-dashboard-status--warning">
                        <div class="reporting-dashboard-status__icon"></div>
                        <div class="reporting-dashboard-status__text">
                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsCoursesCompletionNoData}
                        </div>
                    </div>
                `);

				// Append notice
				$container.append($notice);
			}

			// Bind button to show all courses
			let $showAllElements = {
				btn: $('#reporting-completed-ranking-middle__points'),
				items: $('#reporting-completed-ranking-middle__items')
			}

			// Listen click
			$showAllElements.btn.on('click', () => {
				// Hide button
				$showAllElements.btn.hide();

				// Show items
				$showAllElements.items.slideToggle(300);
			});

			// Define width of .reporting-completed-ranking__order and .reporting-completed-ranking__percentage
			// Context: Normally we would do this with CSS using a table structure, but in this case
			// we have each row separated in three different containers; in the first container
			// .reporting-completed-ranking__order can have 1 digit, while in the third container
			// that element can have 2 digits (or even more in big sites). So to fix this we have to use JS
			let fixedWidth = {
				order: 0,
				percentage: 0
			}

			$('.reporting-completed-ranking__order').each((index, element) => {
				// Get cell width
				let cellWidth = $(element).width();

				// Check if it's the biggest one
				fixedWidth.order = fixedWidth.order < cellWidth ? cellWidth : fixedWidth.order;
			});

			$('.reporting-completed-ranking__percentage').each((index, element) => {
				// Get cell width
				let cellWidth = $(element).width();

				// Check if it's the biggest one
				fixedWidth.percentage = fixedWidth.percentage < cellWidth ? cellWidth : fixedWidth.percentage;
			});

			$('.reporting-completed-ranking__order').css({
				width: `${fixedWidth.order}px`
			});

			$('.reporting-completed-ranking__percentage').css({
				width: `${fixedWidth.percentage}px`
			});
		},

		groupSelector: function () {
			// Get group selector
			let $groupSelector = $('#reporting-group-selector');

			// Check if it exists
			if ($groupSelector.length == 1) {
				// Init select2
				$groupSelector.select2({
					theme: 'default',
					dropdownCssClass: 'tclr-select2',
					language: {
						errorLoading: function () {
							return TincannyData.i18n.dropdown.errorLoading
						},
						inputTooLong: function (e) {
							var n = e.input.length - e.maximum;

							if (n == 1) {
								return TincannyData.i18n.dropdown.inputTooLong.singular;
							} else {
								return TincannyData.i18n.dropdown.inputTooLong.plural.replace('%s', n);
							}
						},
						inputTooShort: function (e) {
							return TincannyData.i18n.dropdown.inputTooShort.replace('%s', (e.minimum - e.input.length));
						},
						loadingMore: function () {
							return TincannyData.i18n.dropdown.loadingMore;
						},
						maximumSelected: function (e) {
							if (e.maximum == 1) {
								return TincannyData.i18n.dropdown.maximumSelected.singular;
							} else {
								return TincannyData.i18n.dropdown.maximumSelected.plural.replace('%s', e.maximum);
							}
						},
						noResults: function () {
							return TincannyData.i18n.dropdown.noResults;
						},
						searching: function () {
							return TincannyData.i18n.dropdown.searching;
						},
						removeAllItems: function () {
							return TincannyData.i18n.dropdown.removeAllItems;
						}
					},
				});
			}
		},

		html: `
            <div class="tclr uo-reporting-dashboard-container">
                <div class="reporting-dashboard-col-container reporting-dashboard-col-1">
                    <div class="reporting-dashboard-col-inner-container">
                        <div class="reporting-dashboard-col-heading">${reportingApiSetup.localizedStrings.overviewBoxesTitleReports}</div>
                        <div class="reporting-dashboard-col-content">
                            <div class="reporting-dashboard-quick-links">
                                <div class="reporting-dashboard-quick-links__item" data-id="courseReportTab" data-append="">
                                    <div class="reporting-dashboard-quick-links__icon">
                                        <span class="tincanny-icon tincanny-icon-book"></span>
                                    </div>
                                    <div class="reporting-dashboard-quick-links__content">
                                        <div class="reporting-dashboard-quick-links__title">
                                            ${sprintf(reportingApiSetup.localizedStrings.overviewBoxesReportsCourseReportTitle, reportingApiSetup.learnDashLabels.course)}
                                        </div>
                                        <div class="reporting-dashboard-quick-links__description">
                                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsCourseReportDescription}
                                        </div>
                                    </div>
                                </div>
                                <div class="reporting-dashboard-quick-links__item" data-id="userReportTab" data-append="&tab=userReportTab">
                                    <div class="reporting-dashboard-quick-links__icon">
                                        <span class="tincanny-icon tincanny-icon-user"></span>
                                    </div>
                                    <div class="reporting-dashboard-quick-links__content">
                                        <div class="reporting-dashboard-quick-links__title">
                                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsUserReportTitle}
                                        </div>
                                        <div class="reporting-dashboard-quick-links__description">
                                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsUserReportDescription}
                                        </div>
                                    </div>
                                </div>
                                <div class="reporting-dashboard-quick-links__item" data-id="tin-can" data-append="&tab=tin-can">
                                    <div class="reporting-dashboard-quick-links__icon">
                                        <span class="tincanny-icon tincanny-icon-chart-bar"></span>
                                    </div>
                                    <div class="reporting-dashboard-quick-links__content">
                                        <div class="reporting-dashboard-quick-links__title">
                                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsTinCanReportTitle}
                                        </div>
                                        <div class="reporting-dashboard-quick-links__description">
                                            ${reportingApiSetup.localizedStrings.overviewBoxesReportsTinCanReportDescription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="reporting-dashboard-quick-stats">
                                <div class="reporting-dashboard-quick-stats__item" data-id="users">
                                    <div class="reporting-dashboard-quick-stats__number">-</div>
                                    <div class="reporting-dashboard-quick-stats__description">${reportingApiSetup.localizedStrings.overviewUsers}</div>
                                </div>
                                <div class="reporting-dashboard-quick-stats__item" data-id="courses">
                                    <div class="reporting-dashboard-quick-stats__number">-</div>
                                    <div class="reporting-dashboard-quick-stats__description">${reportingApiSetup.learnDashLabels.courses}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
                    #reporting-recent-activities {
                        width: 100%;
                        height: 250px;
                    }
                    #courseSingleOverviewPieChart {
                        width: 100%;
                        height: 250px;
                    }
                    #courseSingleActivitiesGraph {
                        width: 100%;
                        height: 350px;
                    }
                </style>
                <div class="reporting-dashboard-col-container reporting-dashboard-col-2">
                    <div class="reporting-dashboard-col-inner-container">
                        <div class="reporting-dashboard-col-heading">${reportingApiSetup.localizedStrings.overviewBoxesTitleRecentActivities}</div>
                        <div class="reporting-dashboard-col-content reporting-dashboard-col-content--small-padding">
                            <div id="reporting-recent-activities" class="reporting-recent-activities">
                                <div class="reporting-dashboard-status reporting-dashboard-status--loading">
                                    <div class="reporting-dashboard-status__icon"></div>
                                    <div class="reporting-dashboard-status__text">
                                        ${reportingApiSetup.localizedStrings.overviewLoading}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reporting-dashboard-col-container reporting-dashboard-col-3">
                    <div class="reporting-dashboard-col-inner-container">
                        <div class="reporting-dashboard-col-heading">
                            ${sprintf(reportingApiSetup.localizedStrings.overviewBoxesTitleCompletedCourses, reportingApiSetup.learnDashLabels.courses)}
                        </div>
                        <div class="reporting-dashboard-col-content">
                            <div class="reporting-completed-ranking" id="reporting-completed-ranking">
                                <div class="reporting-dashboard-status reporting-dashboard-status--loading">
                                    <div class="reporting-dashboard-status__icon"></div>
                                    <div class="reporting-dashboard-status__text">
                                        ${reportingApiSetup.localizedStrings.overviewLoading}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
	};

	tinCannyDashboard.init();
});

export {
	tinCannyDashboard
}
